import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/HomeView.vue';
import Privacy from '../views/PrivacyView.vue';
import Cookies from '../views/CookiesView.vue';

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { title: "Home | RM Software Services Ltd" },
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: Privacy,
    meta: { title: "Privacy | RM Software Services Ltd" },
  },
  {
    path: "/cookies",
    name: "Cookies",
    component: Cookies,
    props: true,
    meta: { title: "Cookies | RM Software Services Ltd" },
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 1️⃣ If there is a saved position (back/forward buttons)
    if (savedPosition) {
      return savedPosition;
    }

    // 2️⃣ If the route has a hash (e.g., #about)
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'   // <-- This triggers smooth scrolling
      };
    }

    // 3️⃣ Default scroll to top
    return { top: 0 };
  }
});

// Update document title after navigation
router.afterEach((to) => {
  if (to.meta?.title) {
    let title = to.meta.title;

    // Check environment variable instead of hostname
    if (process.env.VUE_APP_ENV === "staging") {
      title = `[STAGING] ${title}`;
    }

    // Check environment variable instead of hostname
    if (process.env.VUE_APP_ENV === "development") {
      title = `[DEVELOPMENT] ${title}`;
    }

    document.title = title;
  }
});

export default router;
